/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { AETRActivity } from '../models/AETRActivity';
import type { AetrPeriod } from '../models/AetrPeriod';
import type { AETRStats } from '../models/AETRStats';
import type { EndDate } from '../models/EndDate';
import type { StartDate } from '../models/StartDate';
import type { UserId } from '../models/UserId';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class AetrService {
    constructor(public readonly http: HttpClient) {}
    /**
     * Get operator AETR status
     * Get operator AETR
     * @param operatorId Operator ID
     * @returns any OK
     * @throws ApiError
     */
    public operatorAetr(
        operatorId: string,
    ): Observable<{
        current_driving?: AetrPeriod;
        daily_period?: AetrPeriod;
        /**
         * Current rest time (sec)
         */
        rest_in_progress?: number | null;
        weekly_period?: (AetrPeriod & {
            /**
             * Available drive stretch (days)
             */
            available_drive_stretch: number | null;
            /**
             * Available rest cut (days)
             */
            available_rest_cut: number | null;
        });
    }> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/operators/{operator_id}/aetr_status',
            path: {
                'operator_id': operatorId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                500: `Server error`,
            },
        });
    }
    /**
     * Daily operator AETR
     * Get daily operator AETR
     * @param operatorId
     * @param startDate
     * @param endDate
     * @returns any OK
     * @throws ApiError
     */
    public aetrDaily(
        operatorId: UserId,
        startDate: StartDate,
        endDate?: EndDate,
    ): Observable<Array<{
        activities: Array<AETRActivity>;
        /**
         * Date
         */
        date: string;
        stats: AETRStats;
    }>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/aetr/{operator_id}/daily',
            path: {
                'operator_id': operatorId,
            },
            query: {
                'start_date': startDate,
                'end_date': endDate,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * AETR summary
     * Get operator AETR summary
     * @param operatorId
     * @param startDate
     * @param endDate
     * @returns any OK
     * @throws ApiError
     */
    public aetrSummary(
        operatorId: UserId,
        startDate: StartDate,
        endDate?: EndDate,
    ): Observable<{
        /**
         * End date
         */
        end_date: string;
        /**
         * Start date
         */
        start_date: string;
        stats: AETRStats;
    }> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/aetr/{operator_id}/',
            path: {
                'operator_id': operatorId,
            },
            query: {
                'start_date': startDate,
                'end_date': endDate,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
}
